<template>
  <div>
    <template v-for="(item, index) in list">
      <!-- 因为有子集和无子集渲染html标签不一样，所以要分为两种情况
           情况一：有子集的情况：                         -->
      <el-submenu v-if="!hasOneChil(item)" :key="index.name" :index="item.name">
        <template slot="title">
          <span>{{ item.title }}</span>
        </template>
        <menu-tree :list="item.children"></menu-tree>
      </el-submenu>
      <!-- 情况二：没子集的情况： -->
      <el-menu-item v-else :key="index.name" :index="item.name">
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MenuTree',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // 是否有子节点
    hasOneChil(item) {
      return !Object.prototype.hasOwnProperty.call(item, 'children')
    }
  }
}
</script>

<style scoped></style>
